import HomeIcon from '@bv/components/icons/HomeIcon.vue';
import { RouteRecordRaw } from '@bv/router';

export const dashboardRoutes: RouteRecordRaw = {
  path: '',
  name: 'dashboard-view',
  component: () => import('@/views/Main/DashboardView.vue'),
  redirect: { name: 'dashboard' },
  meta: {
    header: { title: 'GLOBAL.TOP_BAR.HOME', icon: HomeIcon },
    breadcrumbs: [
      {
        label: 'GLOBAL.TOP_BAR.HOME',
        route: { name: 'dashboard' },
      },
    ],
  },
  children: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/components/Dashboard/Dashboard.vue'),
    },
  ],
};
